import { ISnotrRoute } from '..';

export default [
  {
    path: '/timesheets',
    name: 'Timesheets',
    meta: {
      title: 'TabTitle.timesheets',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/timesheet/timesheets.vue'),
  },
] as ISnotrRoute[];

